'use client';

import { useTranslations } from 'next-intl';
import type React from 'react';

import Modal from '@/components/Modal';

export type ProgramDetailDateOption = {
    key: string;
    label: string;
    count: number;
};

type ProgramDetailDatesModalProps = {
    isOpen: boolean;
    dates: ProgramDetailDateOption[];
    onSelect: (key: string) => void;
    onClose: () => void;
};

/** Every date that has screenings, for jumping far ahead without scrolling the tab bar. */
export default function ProgramDetailDatesModal(props: ProgramDetailDatesModalProps): React.JSX.Element {
    const { isOpen, dates, onSelect, onClose } = props;
    const t = useTranslations();

    return (
        <>
            {isOpen && (
                <Modal
                    modalIsOpen={isOpen}
                    onClose={onClose}
                    title={t('program-detail.screenings')}
                    titleClassName="text-headline-20 leading-[28px] lg:text-headline-24 lg:leading-[32px] tracking-[0.48px]"
                    className="lg:max-w-[660px]">
                    <ul className="min-h-0 overflow-y-auto pb-24 lg:pb-8">
                        {dates.map((date) => (
                            <li key={date.key}>
                                <button
                                    type="button"
                                    onClick={() => onSelect(date.key)}
                                    className="flex h-40 w-full items-end justify-between py-8 text-body-14 leading-[24px] tracking-[0.2px] cursor-pointer hover:bg-[rgba(var(--on-surface-color-rgb),0.1)] rounded-4">
                                    <span>{date.label}</span>
                                    <span className="italic opacity-70">
                                        {t('program-detail.screenings-count', { count: date.count })}
                                    </span>
                                </button>
                            </li>
                        ))}
                    </ul>
                </Modal>
            )}
        </>
    );
}
